document.addEventListener('DOMContentLoaded', () => {
  // 'js-question' IDを持つ要素を取得
  const question = document.getElementById('js-question');

  // question要素が存在する場合のみ、処理を実行
  if (question) {
    // .thread-comment .answer を持つ要素が1つ以上あるとき、コメントの最後までスクロールする
    const answerElements = document.querySelectorAll('.thread-comment.answer');

    if (answerElements.length > 0) {
      // 取得したリストから、一番最後の要素を取得
      const lastAnswerElement = answerElements[answerElements.length - 1];

      // 最後の回答要素の、ページ全体の上端からのY座標（位置）を計算
      const elementTop = lastAnswerElement.getBoundingClientRect().top + window.pageYOffset;

      // ヘッダの高さを考慮
      const header = document.querySelector('.header');
      window.scrollTo({
        top: elementTop - header.clientHeight,
        behavior: 'smooth'
      });
    }
  }
});